import { i18n } from '../../i18n';
import { ValidatorCallback } from './validators';

export const validateName = (_rule: string, value: string, cb: ValidatorCallback): void => {
  const isValid = /^[a-zA-Z0-9]*$/gm.test(value);

  if (isValid) {
    cb();
  } else {
    cb(i18n.t('common:validation.name'));
  }
};
